module.exports = __webpack_public_path__ + "res/ic_menu_rewards_won_s.7ae964fcd845b054465291aba7e3dc61.png";